import * as React from 'react';
import { cn } from '@/lib/utils';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  interactive?: boolean;
}

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ className, interactive = false, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'bg-background-subtle rounded-lg p-card border border-transparent transition-all duration-150',
        interactive && 'cursor-pointer hover:border-border hover:bg-background-elevated hover:scale-[1.01]',
        !interactive && 'hover:border-border hover:bg-background-elevated',
        className
      )}
      {...props}
    />
  )
);
Card.displayName = 'Card';

export { Card };